import React, {useEffect, useMemo} from "react";
import {ProductsFilter} from '../../modules/ProductsFilter';
import {ProductsTable} from '../../modules/ProductTable';
import {columns} from "../../modules/ProductTable/ui.helpers";
import {useProductsUIContext} from "../../../contexts/ProductsUIContext";
import {shallowEqual, useDispatch, useSelector} from "react-redux";
import {fetchProducts} from "../../../../redux/modules/products/actions";
import {fetchCategories} from "../../../../redux/modules/categories/actions";

export function ProductsContainer() {
  const context = useProductsUIContext();
  const dispatch = useDispatch();

  const {queryParams} = useMemo(() => ({
    queryParams: context.queryParams,
  }), [context]);

  const {productStore, categoryStore} = useSelector(state => ({
    productStore: state.products,
    categoryStore: state.categories,
  }), shallowEqual);

  useEffect(() => {
    dispatch(fetchProducts(queryParams));
  }, [queryParams, dispatch]);

  useEffect(() => {
    dispatch(fetchCategories());
  }, [dispatch]);

  const {totalCount, productList, listLoading} = productStore;
  const {categories} = categoryStore;

  return (
    <div className="flex-grow-1">
      {/* Start:: ProductsFilter */}
      <div className="mb-10">
        <ProductsFilter categories={categories} />
      </div>
      {/* End:: ProductsFilter */}

      {/* Start:: ProductsFilter */}
      <ProductsTable
        columns={columns}
        totalCount={totalCount}
        productList={productList}
        listLoading={listLoading}
      />
      {/* End:: ProductsFilter */}
    </div>
  );
}
